import request from '@/utils/request'

/**
 * 获取员工详情
 * @param {Object} params 请求参数
 * @returns {Promise} Promise对象
 */
export function getStaffDetail(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/query.staff.infos',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 获取员工组织
 * @param {Object} params 请求参数
 * @returns {Promise} Promise对象
 */
export function getStaffOrgs(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/user.listStaffOrgs',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 获取员工角色
 * @param {Object} params 请求参数
 * @returns {Promise} Promise对象
 */
export function getStaffRoles(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/user.listStaffRoles',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 获取员工权限
 * @param {Object} params 请求参数
 * @returns {Promise} Promise对象
 */
export function getStaffPrivileges(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/privilege.queryStaffPrivileges',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}